'use client';
import { ComponentType } from 'react';
import clsx from 'clsx';

interface FloatingIconProps {
  link: string;
  icon: ComponentType<{ className?: string }> | any;
  isVisible?: boolean;
  dataTestId?: string;
  customClass?: string;
  alt?: string;
}

function FloatingIcon({
  link,
  icon: Icon,
  isVisible = true,
  dataTestId = 'floating-icon',
  customClass,
  alt = 'floating-icon',
}: Readonly<FloatingIconProps>) {
  const isImageSource = typeof Icon === 'string';

  return (
    <div
      data-testid={dataTestId}
      className={clsx(
        'fixed right-[1.375rem] z-50 w-[60px] h-[60px]',
        isVisible && 'sm:bottom-[10.25rem] md:bottom-[10.875rem]',
        !isVisible && 'md:bottom-[4.875rem] sm:bottom-[4.25rem]',
        customClass
      )}
    >
      <a
        href={link}
        target="_blank"
        rel="noreferrer noopener"
        className="block w-full h-full"
        data-testid={`${dataTestId}-link`}
      >
        {isImageSource ? (
          <img
            src={Icon as string}
            alt={alt}
            width={60}
            height={60}
            data-testid={`${dataTestId}-icon`}
            className="w-full h-full"
          />
        ) : (
          <div data-testid={`${dataTestId}-icon`} className="w-full h-full">
            {typeof Icon === 'function' && <Icon className="w-full h-full" />}
          </div>
        )}
      </a>
    </div>
  );
}

export default FloatingIcon;
